export const ARTICLES_FILTER_QUERY = "tag";

export const ARTICLES_PAGE_SIZE = 32;
